import React, { memo, useState, useEffect } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import { Hits, useInstantSearch } from 'react-instantsearch-hooks-web';
import SearchResultsHit from './SearchResultsHit';
import PaginationBar from '../PaginationBar/PaginationBar';
import NoSearchResultsFound from '../NoSearchResultsFound/NoSearchResultsFound';
import { pushToDataLayer } from '../../utils/pushToDataLayer/pushToDataLayer.util';

interface SearchResultsListProps {
  pagination_footer_text: string;
  no_results_found_title: string;
  no_results_found_body?: string;
}

const SearchResultsList: React.FC<SearchResultsListProps> = ({
  pagination_footer_text,
  no_results_found_title,
  no_results_found_body = undefined,
}) => {
  const { results } = useInstantSearch();
  const { query, nbHits, hitsPerPage } = results;

  const [hasAlreadyPushedToDataLayer, setHasAlreadyPushedToDataLayer] =
    useState<boolean>(false);

  useEffect(() => {
    if (results.query && !hasAlreadyPushedToDataLayer) {
      pushToDataLayer({
        event: 'view_search_results',
        data: {
          search_term: results.query,
          search_results: results.nbHits,
        },
      });
      setHasAlreadyPushedToDataLayer(true);
    }
  }, [results]);

  return (
    <>
      {query && (
        <>
          {nbHits > 0 && (
            <section className="py-12 lg:py-16">
              <Container>
                <Grid>
                  <Col span={{ md: 10, lg: 8 }} start={{ md: 2, lg: 3 }}>
                    {query && (
                      <>
                        {nbHits > 0 && (
                          <div className="space-y-6">
                            <Hits hitComponent={SearchResultsHit} />
                            {nbHits > hitsPerPage && (
                              <PaginationBar
                                pagination_footer_text={pagination_footer_text}
                              />
                            )}
                          </div>
                        )}
                        {nbHits === 0 && (
                          <NoSearchResultsFound
                            heading={no_results_found_title}
                            body={no_results_found_body}
                          />
                        )}
                      </>
                    )}
                  </Col>
                </Grid>
              </Container>
            </section>
          )}
          {nbHits === 0 && (
            <NoSearchResultsFound
              heading={no_results_found_title}
              body={no_results_found_body}
            />
          )}
        </>
      )}
    </>
  );
};

export default memo(withBlokWrapper(SearchResultsList, Theme.LIGHT));
